import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const carouselImages = [
  { src: '/1.png' },
  { src: '/2.png' },
  { src: '/3.png' },
  { src: '/4.png' }
];

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="main-layout">
      {/* Responsive Inline Styles Overlay */}
      <style>{`
        /* Responsive Layout Rules */
        .main-layout {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
          padding: 12px;
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          box-sizing: border-box;
          overflow-x: hidden; /* Strict defense against horizontal page leaks */
        }

        /* Desktop Layout Override */
        @media (min-width: 992px) {
          .main-layout {
            grid-template-columns: 250px 1fr 280px;
          }
          .left-sidebar { order: 1; }
          .center-content { order: 2; }
          .right-sidebar { order: 3; }
        }

        /* Order adjustments for mobile reading flow */
        @media (max-width: 991px) {
          .center-content { order: 1; }
          .left-sidebar { order: 2; }
          .right-sidebar { order: 3; }
        }

        /* Center Content Core Boundaries */
        .center-content {
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          overflow: hidden;
        }

        /* Sidebars UI consistency & Mobile Overflow Fixes */
        .left-sidebar, .right-sidebar {
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          overflow: hidden;
        }

        /* Fixes for the cutting content inside the sidebars cards/lists */
        .notice-card-item {
          display: block;
          width: 100%;
          box-sizing: border-box;
          padding: 12px;
          white-space: normal !important;       
          word-wrap: break-word !important;     
          overflow-wrap: break-word !important; 
        }

        .activities-container {
          width: 100%;
          box-sizing: border-box;
          padding: 12px;
        }

        .activity-list {
          width: 100%;
          box-sizing: border-box;
          padding: 0;
        }

        .activity-list li {
          word-wrap: break-word;
          overflow-wrap: break-word;
          white-space: normal;
        }

        /* Responsive Capsule Grid buttons */
        .capsule-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin: 20px 0;
          width: 100%;
          box-sizing: border-box;
        }
        .capsule-btn {
          flex: 1 1 calc(50% - 10px);
          min-width: 140px;
          box-sizing: border-box;
        }
        @media (max-width: 480px) {
          .capsule-btn {
            flex: 1 1 100%;
          }
        }

        /* Responsive Info Tab Headers */
        .tab-headers {
          display: flex;
          flex-direction: column;
          gap: 5px;
          border-bottom: none;
        }
        @media (min-width: 600px) {
          .tab-headers {
            flex-direction: row;
            gap: 15px;
          }
        }

        /* Analysis Metrics Layout Fixes */
        .analysis-section {
          width: 100%;
          box-sizing: border-box;
          overflow: hidden;
        }

        .section-header-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
          width: 100%;
        }

        .section-header-box h3 {
          font-size: clamp(1.1rem, 4.5vw, 1.4rem);
          margin: 0;
          white-space: normal;
        }

        /* Responsive Metric Statistics Grid - Splits perfectly on mobile */
        .stats-inner-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 10px !important;
          margin: 15px 0;
          width: 100%;
          box-sizing: border-box;
        }

        .stat-unit-box {
          width: 100%;
          box-sizing: border-box;
          padding: 10px !important;
          overflow: hidden;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
        }

        .stat-unit-box h2 {
          font-size: clamp(1.3rem, 5vw, 1.8rem) !important;
          margin: 0 0 4px 0;
        }

        .stat-unit-box p {
          font-size: 0.75rem !important;
          line-height: 1.3;
          margin: 0;
          white-space: normal !important;
        }

        /* Responsive Specialty Bar Chart Wrapper */
        .chart-wrapper-box {
          width: 100%;
          box-sizing: border-box;
          padding: 12px;
          overflow: hidden;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          margin-top: 15px;
        }

        .chart-wrapper-box h4 {
          font-size: 0.95rem !important;
          white-space: normal !important;
          margin: 0 0 15px 0;
          line-height: 1.4;
        }

        .bar-graph-mock {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          height: 160px;
          padding: 10px 4px;
          box-sizing: border-box;
          gap: 8px;
          width: 100%;
        }

        .graph-bar {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          font-size: 11px;
          text-align: center;
          min-width: 0;
        }

        .graph-bar label {
          font-size: 9px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          margin-top: 6px;
        }

        /* Responsive Scrollable/Flex Publication chips and grid */
        .publications-section {
          width: 100%;
          box-sizing: border-box;
          overflow: hidden;
        }

        .pub-scroll-tabs {
          display: flex;
          overflow-x: auto !important;
          white-space: nowrap;
          gap: 10px;
          padding-bottom: 8px;
          width: 100%;
          box-sizing: border-box;
          -webkit-overflow-scrolling: touch;
        }

        .pub-chip {
          flex-shrink: 0;
        }

        .books-row-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
          gap: 15px;
          width: 100%;
          box-sizing: border-box;
        }

        /* Responsive Carousel Adjustments */
        @media (max-width: 600px) {
          .main-slider-box {
            height: 180px !important;
          }
        }
      `}</style>
      
      {/* LEFT SIDEBAR: PURE MEDICAL TOURISM LINKS */}
      <aside className="left-sidebar">
        <ul className="nhrc-menu">
          <li><Link to="/visa-guides">Medical Visa Step-by-Step Guide <span className="arrow">→</span></Link></li>
          <li><Link to="/compare-costs">Compare Treatment Costs Globally <span className="arrow">→</span></Link></li>
          <li><Link to="/cardiology">Cardiology (Heart Bypass/CABG) <span className="arrow">→</span></Link></li>
          <li><Link to="/orthopedics">Knee & Hip Joint Replacement <span className="arrow">→</span></Link></li>
          <li><Link to="/oncology">Cancer Care & Bone Marrow <span className="arrow">→</span></Link></li>
          <li><Link to="/dental">Affordable Dental Packages <span className="arrow">→</span></Link></li>
          <li><Link to="/destinations">Top Medical Destinations Guide <span className="arrow">→</span></Link></li>
          <li><Link to="/hospitals">Find Private Corporate Hospitals <span className="arrow">→</span></Link></li>
        </ul>
      </aside>

      {/* CENTER CONTENT SYSTEM */}
      <main className="center-content">
        
        {/* AUTO-SLIDING CAROUSEL BOX */}
        <div className="main-slider-box" style={{ overflow: 'hidden', position: 'relative', height: '250px', width: '100%' }}>
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img 
              src={carouselImages[currentIndex].src} 
              alt={`Slide ${currentIndex + 1}`} 
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
        </div>

        {/* CAPSULE GRID BUTTONS */}
        <div className="capsule-grid">
          <Link to="/submit-query" className="capsule-btn green" style={{ textDecoration: 'none', textAlign: 'center' }}>Submit Patient Query</Link>
          <Link to="/compare-costs" className="capsule-btn white" style={{ textDecoration: 'none', textAlign: 'center' }}>Estimate Cost</Link>
          <Link to="/hospitals" className="capsule-btn white" style={{ textDecoration: 'none', textAlign: 'center' }}>Find Private Hospitals</Link>
          <Link to="/doctor-consultation" className="capsule-btn white" style={{ textDecoration: 'none', textAlign: 'center' }}>Doctor Consultation</Link>
          <Link to="/visa-assistance" className="capsule-btn white" style={{ textDecoration: 'none', textAlign: 'center' }}>Visa Assistance</Link>
        </div>

        {/* TAB LIST SYSTEM */}
        <section className="info-tab-section">
          <div className="tab-headers">
            <Link to="/medical-updates" className="tab-link active" style={{ textDecoration: 'none' }}>Latest Medical Updates</Link>
            <Link to="/success-stories" className="tab-link" style={{ textDecoration: 'none' }}>Patient Success Stories</Link>
            <Link to="/travel-advisories" className="tab-link" style={{ textDecoration: 'none' }}>Travel Advisories</Link>
          </div>
          <div className="tab-content-list">
            <div className="news-item">
              <span className="n-date">23 May 2026</span>
              <p><strong>New Guidelines:</strong> Step-by-step electronic Medical Visa processing timeline updated for international patients.</p>
            </div>
            <div className="news-item">
              <span className="n-date">20 May 2026</span>
              <p>Top private multi-specialty hospitals in Delhi NCR expand access to robotic prostate and joint replacement systems.</p>
            </div>
            <div className="more-link-container">
              <Link to="/medical-updates" className="more-btn-style" style={{ textDecoration: 'none', display: 'inline-block' }}>▶ View All News...</Link>
            </div>
          </div>
        </section>

        {/* ANALYSIS OF PATIENT TRAFFIC */}
        <section className="analysis-section">
          <div className="section-header-box">
            <h3>Analysis of Patient Research Metrics (2026)</h3>
            <Link to="/hospitals" className="view-more-btn" style={{ textDecoration: 'none' }}>Global Records</Link>
          </div>
          
          <div className="stats-inner-grid">
            <div className="stat-unit-box">
              <h2>12,497</h2>
              <p>Total Patient Information Requests</p>
            </div>
            <div className="stat-unit-box blue-text">
              <h2>2,607</h2>
              <p>Independent Cost Profiles Tracked</p>
            </div>
            <div className="stat-unit-box green-text">
              <h2>8,154</h2>
              <p>Accredited Private Facilities Indexed</p>
            </div>
            <div className="stat-unit-box">
              <h2>1,736</h2>
              <p>Visa Guidelines Forms Completed</p>
            </div>
          </div>

          {/* GRAPH MODEL */}
          <div className="chart-wrapper-box">
            <h4>Information Requests by Specialty Area (2025-2026)</h4>
            <div className="bar-graph-mock">
              <Link to="/cardiology" className="graph-bar" style={{height: '85%', textDecoration: 'none'}}><span className="bar-val">4.1k</span><label>Cardiology</label></Link>
              <Link to="/orthopedics" className="graph-bar" style={{height: '65%', textDecoration: 'none'}}><span className="bar-val">3.2k</span><label>Orthopedics</label></Link>
              <Link to="/oncology" className="graph-bar light-blue" style={{height: '50%', textDecoration: 'none'}}><span className="bar-val">2.4k</span><label>Oncology</label></Link>
              <Link to="/dental" className="graph-bar green-bar" style={{height: '75%', textDecoration: 'none'}}><span className="bar-val">3.6k</span><label>Dental Care</label></Link>
            </div>
          </div>
        </section>

        {/* HEALTH PUBLICATIONS */}
        <section className="publications-section">
          <h3>Patient Information & Research Manuals</h3>
          <div className="pub-scroll-tabs">
            <span className="pub-chip active">Health Newsletters</span>
            <span className="pub-chip">Visa Manuals</span>
            <span className="pub-chip">Cost Comparison Reports</span>
          </div>
          <div className="books-row-grid">
            <Link to="/cardiology" className="m-book-card" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="m-book-cover">📘 Heart Care Guide</div>
              <p className="m-book-title">May 2026 Edition</p>
              <span className="m-arrow-circle">→</span>
            </Link>
            <Link to="/visa-guides" className="m-book-card" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="m-book-cover cover-blue">📙 Medical Visa Manual</div>
              <p className="m-book-title">April 2026 Edition</p>
              <span className="m-arrow-circle">→</span>
            </Link>
          </div>
        </section>
      </main>

      {/* RIGHT SIDEBAR: UTILITIES */}
      <aside className="right-sidebar">
        <div className="activities-container">
          <h3>Services Toolkit</h3>
          <ul className="activity-list" style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ margin: '10px 0' }}><Link to="/treatments" style={{ textDecoration: 'none', color: 'inherit' }}>▪ Private Specialty Care Check</Link></li>
            <li style={{ margin: '10px 0' }}><Link to="/tele-consultation" style={{ textDecoration: 'none', color: 'inherit' }}>▪ Pre-Departure Tele-Consultation</Link></li>
            <li style={{ margin: '10px 0' }}><Link to="/compare-costs" style={{ textDecoration: 'none', color: 'inherit' }}>▪ Hospital Cost Comparison Quotes</Link></li>
            <li style={{ margin: '10px 0' }}><Link to="/visa-processing" style={{ textDecoration: 'none', color: 'inherit' }}>▪ Medical Visa Invitation Processing</Link></li>
            <li style={{ margin: '10px 0' }}><Link to="/follow-up-care" style={{ textDecoration: 'none', color: 'inherit' }}>▪ Post-Discharge Follow-up Care</Link></li>
          </ul>
        </div>

        <div className="notices-vertical-stack">
          <Link to="/doctor-network" className="notice-card-item" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <p><strong>Doctor Network:</strong> Access open independent registries for checking credential background metrics of senior consultants. Update timeline: 30.06.2026</p>
            <span className="notice-arrow">→</span>
          </Link>
          <Link to="/patient-support" className="notice-card-item" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <p><strong>Patient Support:</strong> Review standard administrative metrics, language assistance desks, and concierge availability logs. Clear track: 15.07.2026</p>
            <span className="notice-arrow">→</span>
          </Link>
        </div>
      </aside>

    </div>
  );
}

export default Home;